import React from "react";
import { Link } from "react-router-dom";
import useContent from "../../services/contentful/content";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const style = {
  background: "#eff4f6",
  padding: "8px",
  fontWeight: "400",
};

const m3pstyle = {
  backgroundColor: "#eff4F6",
  //backgroundColor: "#fff",
  marginTop: "30px",
  //background: "rgb(91,192,222)",
  //background: "-moz-linear-gradient(top, rgba(255,255,255,1) 0%, rgba(238,244,246,1) 100%)",
  //background: "-webkit-linear-gradient(top, rgba(255,255,255,1) 0%,rgba(238,244,246,1) 100%)",
  ////background: "linear-gradient(to bottom, rgba(31,129,174,1) 0%,rgba(255,255,255,1) 100%)",
  //background: "linear-gradient(to bottom, rgba(91,192,222,1) 0%,rgba(255,255,255,1) 100%)",
  //filter: "progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#eef4f6',GradientType=0 )",
  //border: "1px solid #BBD7D3",
};

const Home = () => {
  const [content, isLoading] = useContent("35Bsghrjp3ZOQpErEuNAcV");

  if (isLoading) return <p>Loading...</p>;

  // console.log(content);

  //console.log(content.sys.updatedAt);

  return (
    <div className="dialog-off-canvas-main-canvas" >
      <div className="col-xs-12 p-0 slider-area" style={{ height: "auto", minHeight: "300px", overflow: "visible" }}>
        <div>
          <div className="region region-slider">
            <section
              className="views-element-container block block-views block-views-blockcontent-views-block-4 clearfix"
              id="block-views-block-content-views-block-4"
            >
              <div
                block="block-views-block-content-views-block-4"
                className="form-group"
              >
                <div className="view view-content-views view-id-content_views view-display-id-block_4">
                  <div className="view-content">


                    <div
                      style={{
                        width: "100%",
                        maxWidth: "1400px",
                        margin: "0 auto",
                        display: "grid",
                      }}
                    >
                      {/* Image — clipped to 3:1 ratio */}
                      <div style={{ gridArea: "1 / 1", overflow: "hidden" }}>
                        <img
                          src={content.contentModules[0].fields.backgroundImage.fields.file.url}
                          alt=""
                          style={{
                            width: "100%",
                            height: "100%",
                            aspectRatio: "7 / 2",
                            objectFit: "cover",
                            display: "block",
                          }}
                        />
                      </div>
                      {/* Title overlay — same grid cell, never clipped */}
                      <div
                        className="title-text"
                        style={{
                          gridArea: "1 / 1",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          zIndex: 10,
                          color: "#fff",
                          textShadow: "0 2px 8px rgba(0,0,0,0.7)",
                          padding: "20px",
                          textAlign: "center",
                        }}
                      >
                        <h1 style={{ margin: 0 }}>{content.contentModules[0].fields.headline}</h1>
                        <h3 style={{ margin: 0 }}>{content.contentModules[0].fields.subhead}</h3>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <div className="container py-5 d-block clear home-section">
        {/* <div className="col-sm-8 col-md-9">
          <div className="region region-content">
            <article className="standard full clearfix">
              <div className="content">
                <div className="field field--name-body field--type-text-with-summary field--label-hidden field__item">
                  <h1>{content.ModuleHeading}</h1>
                </div>

                <div className="field field--name-field-table-menu field--type-entity-reference-revisions field--label-hidden field__items">
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="field__item left">
                        {" "}
                        <div className="field-collection-container">
                          <div className="field field--name-field-table-description field--type-text-long field--label-hidden field__item">
                            <ReactMarkdown children={content.bodyText} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="field__item right">
                        {" "}
                        <div className="field-collection-container">
                          <div className="field field--name-field-table-description field--type-text-long field--label-hidden field__item">
                            <ReactMarkdown children={content.bodyText2} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                  <div className="row" style={m3pstyle}>
                    <div className="col-sm-6">
                      <div className="field__item left">
                        {" "}
                        <div className="field-collection-container">
                          <div className="field field--name-field-table-description field--type-text-long field--label-hidden field__item">
                            <ReactMarkdown children={content.bodyText3} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="field__item right">
                        {" "}
                        <div className="field-collection-container">
                          <div className="field field--name-field-table-description field--type-text-long field--label-hidden field__item">
                            <ReactMarkdown children={content.bodyText4} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>

                <div className="field field--name-field-add-accordion field--type-entity-reference-revisions field--label-hidden field__items">
                  <div className="field__item">
                    <div id="accordion-4" className="form-group"></div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div> */}

        {/* begin  Explore link boxes */}

        {/* Banner EOB */}
        {content.contentModules[12]?.fields?.shortBodyText && (
          <div style={{ background: "#4db3d3", padding: "40px 20px", marginBottom: "40px", color: "#fff" }}>
            <h1 className="home-section-header" style={{ color: "#fff" }} >
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                components={{
                  a: ({ node, ...props }) => <a {...props} style={{ color: "#1a3a6b", }} />,
                }}
                children={content.contentModules[12].fields.shortBodyText}
              />
            </h1>
          </div>
        )}

        {/* Explore Part D coverage options with MedicareBlue Rx */}
        <h1 className="home-section-header">
          {content.contentModules[1].fields.heading}
        </h1>
        <div className="flex-container homebox">

          <div style={{ marginLeft: 0, textAlign: "center" }}>
            <Link to="Compare/PlanInformation2027">
              <img
                src={
                  content.contentModules[2].fields.icon.fields.file
                    .url
                }
                alt="icon"
              />
            </Link>
            <h3>
              <Link to="Compare/PlanInformation2027">
                {content.contentModules[2].fields.heading}
              </Link>
            </h3>
            <div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={
                  content.contentModules[2].fields.shortBodyText
                }
              />
            </div>
          </div>

          <div style={{ marginLeft: 0, textAlign: "center" }}>
            <Link to="GroupBenefits">
              <img
                src={
                  content.contentModules[3].fields.icon.fields.file
                    .url
                }
                alt="icon"
              />
            </Link>
            <h3>
              <Link to="GroupBenefits">
                {content.contentModules[3].fields.heading}
              </Link>
            </h3>
            <div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={
                  content.contentModules[3].fields.shortBodyText
                }
              />
            </div>
          </div>

        </div>


        {/* Apply for a MedicareBlue Rx plan */}
        <h1 className="home-section-header">
          {content.contentModules[4].fields.heading}
        </h1>
        <div className="flex-container homebox">

          {/* <div style={{ marginLeft: 0, textAlign: "center" }}>
            <Link to="Compare/PlanCompare2025">
              <img
                src={
                  content.contentModules[5].fields.icon.fields.file
                    .url
                }
                alt="icon"
              />
            </Link>
            <h3>
              <Link to="Compare/PlanCompare2025">
                {content.contentModules[5].fields.heading}
              </Link>
            </h3>
            <div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={
                  content.contentModules[5].fields.shortBodyText
                }
              />
            </div>
          </div> */}


          <div style={{ marginLeft: 0, textAlign: "center" }}>
            <Link to="enroll/2027-enroll-now">
              <img
                src={
                  content.contentModules[5].fields.icon.fields.file
                    .url
                }
                alt="icon"
              />
            </Link>
            <h3>
              <Link to="enroll/2027-enroll-now">
                {content.contentModules[5].fields.heading}
              </Link>
            </h3>
            <div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={
                  content.contentModules[5].fields.shortBodyText
                }
              />
            </div>
          </div>


          <div style={{ marginLeft: 0, textAlign: "center" }}>
            <Link to="Contact/contact-form-online">
              <img
                src={
                  content.contentModules[6].fields.icon.fields.file
                    .url
                }
                alt="icon"
              />
            </Link>
            <h3>
              <Link to="Contact/contact-form-online">
                {content.contentModules[6].fields.heading}
              </Link>
            </h3>
            <div>
              <ReactMarkdown
                rehypePlugins={[rehypeRaw]}
                children={
                  content.contentModules[6].fields.shortBodyText
                }
              />
            </div>
          </div>

        </div>

        <br/>

        {/* Find helpful resources */}
        <div style={{ background: "#4db3d3", padding: "40px 20px" }}>
          <h1 className="home-section-header" style={{ color: "#fff" }}>
            {content.contentModules[7].fields.heading}
          </h1>
          <div className="flex-container homebox">
            {/* <div className="flex-container homebox" style={{ height: "375px" }}> */}
            <div className="homebox-item homebox-item-resources" style={{ height: "100%" }}>
              <Link to="/pharmacy-tools-landing">
                <img
                  src={content.contentModules[8].fields.icon.fields.file.url}
                  alt="icon"
                />
              </Link>
              <h3>
                <Link to="/pharmacy-tools-landing">
                  {content.contentModules[8].fields.heading}
                </Link>
              </h3>
              <div className="homebox-left-align">
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  children={content.contentModules[8].fields.shortBodyText}
                />
              </div>
            </div>


            <div className="homebox-item homebox-item-resources" style={{ height: "100%" }}>
              <img
                src={content.contentModules[9].fields.icon.fields.file.url}
                alt="icon"
              />
              <h3>
                {content.contentModules[9].fields.heading}
              </h3>
              <div className="homebox-left-align">
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  children={content.contentModules[9].fields.shortBodyText}
                />
              </div>
            </div>


            <div className="homebox-item homebox-item-resources" style={{ height: "100%" }}>
              <Link to="/pharmacy-tools-landing">
              <img
                src={content.contentModules[10].fields.icon.fields.file.url}
                alt="icon"
              />
              </Link>
              <h3>
                <Link to="/pharmacy-tools-landing">
                {content.contentModules[10].fields.heading}
                </Link>
              </h3>
              <div className="homebox-left-align">
                <ReactMarkdown
                  rehypePlugins={[rehypeRaw]}
                  children={content.contentModules[10].fields.shortBodyText}
                />
              </div>
            </div>
          </div>
        </div>

        {/* end Explore link boxes */}

        <br />
        {/* Manage your Medicare Part D out-of-pocket drug costs */}
        <h1 className="home-section-header">
          {content.contentModules[11].fields.heading}
        </h1>



        <div >          
          <div className="field__item left">
            <div className="field-collection-container">
              <div className="field field--name-field-table-description field--type-text-long field--label-hidden field__item"
                  style={{ margin: "25px 150px" }}
              >
                <ReactMarkdown children={content.contentModules[11].fields.shortBodyText} />
              </div>
            </div>
            {/* </div> */}
          </div>
        </div>






        {/* <aside className="col-sm-4 col-md-3 side-section order-md-1">
          <div className="region region-sidebar-second">
            <section
              id="block-homecontact-3"
              className="contact-gradient p-5 mt-5 block block-block-content block-block-contentc84e5a3b-f998-486b-8e22-4dd0249790fd clearfix"
            >
              <div className="field field--name-body field--type-text-with-summary field--label-hidden field__item">
                <h2>
                  <ReactMarkdown
                    children={content.contentModules[2].fields.titleSidebar1}
                  />
                </h2>

                <ReactMarkdown
                  children={content.contentModules[2].fields.sidebarBodyText}
                />
              </div>
            </section>
          </div>
        </aside> */}

      </div>
    </div >
  );
};

export default Home;
